module.exports = __webpack_public_path__ + "static/media/mgpre1.2e904d98.png";